export default "__VITE_ASSET__TIh1EjPt__"